import { arrayToOptions } from "MODULES/shared/helpers";

export const AS_REMOVED = "as_removed";
export const BEYOND_REPAIR = "beyond_econ_repair";
export const INSPECTED = "inspected";
export const NEW = "new_item";
export const OVERHAULED = "overhauled";
export const REPAIRED = "repaired";

export const AOG = "aog";
export const AS_IS = "as_is";
export const ASSIGN_TO_ME = "assign_to_me";
export const ATTACHMENT_IDS = "attachment_ids";
export const AUTO_FOLLOWUP = "auto_followup";
export const AUTO_FOLLOWUP_DAYS = "auto_followup_days";
export const AWAITING_INFO_TO_COMPLETE = "awaiting_info_to_complete";
export const CORE_VALUE = "core_value";
export const LOCKED = "locked";
export const OUTRIGHT_VALUE = "outright_value";
export const EXCHANGE = "exchange";
export const EXCHANGE_FEE = "exchange_fee";
export const EXCHANGE_ONLY = "exchange_only";
export const FOLLOW_UP_FEEDBACK = "follow_up_feedback";
export const HAS_FOLLOW_UP_FEEDBACK = "has_feedback";
export const INCLUDE_DOM = "include_dom";
export const INVENTORY_IDS = "inventory_ids";
export const INVENTORY_ATTACHMENT_IDS = "inventory_attachment_ids";
export const LOOKING_FOR = "looking_for";
export const MAKE_OFFER = "make_offer";
export const NO_QUOTE = "no_quote";
export const NO_INTEREST = "no_interest";
export const OFFER = "offer";
export const OUTGOING_QUOTE_LINE_ITEM = "outgoing_quote_line_item";
export const PRICE_PER_UNIT = "price_per_unit";
export const QUOTE_TYPE = "quote_type";
export const SELL_AS_ALT_ID = "sell_as_alt_id";
export const SEND_QUOTE = "send_quote";
export const STANDARD = "standard";
export const WARRANTY = "warranty";

export const ATTACH_TRACEABILITY = "attach_traceability";
export const ATTACH_TAG_COPIES = "attach_tag_copies";

export const PRICE_PER_UNIT_OPTIONAL_QUOTE_TYPES = [
  AWAITING_INFO_TO_COMPLETE,
  NO_QUOTE,
  OFFER,
  MAKE_OFFER,
  EXCHANGE_ONLY
];

const OTHER = "other";
const REPAIR_STATION_NOT_APPROVED = "repair_station_not_approved";
const RFQ_IS_STILL_OPEN = "rfq_is_still_open";
const UNACCEPTABLE_TRACE = "unacceptable_trace";
const UNDESIRABLE_CONDITION = "undesirable_condition";
const PRICE_IS_TOO_HIGH = "price_is_too_high";

export const FOLLOW_UP_FEEDBACKS = arrayToOptions([
  REPAIR_STATION_NOT_APPROVED,
  RFQ_IS_STILL_OPEN,
  UNACCEPTABLE_TRACE,
  UNDESIRABLE_CONDITION,
  PRICE_IS_TOO_HIGH,
  OTHER
]);

export const OUTGOING_LINE_ITEMS = {
  condition: {
    [OVERHAULED]: {
      abbrev: "OH",
      label: "Overhauled"
    },
    [REPAIRED]: {
      abbrev: "SV",
      label: "Repaired"
    },
    [INSPECTED]: {
      abbrev: "BT",
      label: "Inspected"
    },
    [NEW]: {
      abbrev: "NE",
      label: "New"
    },
    [AS_REMOVED]: {
      abbrev: "AR",
      label: "As Removed"
    },
    [BEYOND_REPAIR]: {
      abbrev: "BR",
      label: "Beyond Repair"
    }
  },
  quoteType: {
    [STANDARD]: {
      label: "Standard",
      abbrev: "Std"
    },
    [NO_QUOTE]: {
      label: "No Quote",
      abbrev: "NQ"
    },
    [AS_IS]: {
      label: "As Is",
      abbrev: "As Is"
    },
    [MAKE_OFFER]: {
      label: "Make Offer",
      abbrev: "MakeOffer"
    },
    [AWAITING_INFO_TO_COMPLETE]: {
      label: "Awaiting Info To Complete",
      abbrev: "Awaiting"
    },
    [OFFER]: {
      label: "Offer",
      abbrev: "Offer"
    },
    [EXCHANGE_ONLY]: {
      label: "Exchange",
      abbrev: "Exch"
    },
    [AOG]: {
      label: "After-Hours AOG",
      abbrev: "AfterHrs"
    }
  },
  traceTypes: {
    121: {
      label: "121",
      abbrev: "121"
    },
    125: {
      label: "125",
      abbrev: "125"
    },
    129: {
      label: "129",
      abbrev: "129"
    },
    135: {
      label: "135",
      abbrev: "135"
    },
    145: {
      label: "145",
      abbrev: "145"
    },
    part_91: {
      label: "Part 91",
      abbrev: "Part91"
    },
    foreign_part_91: {
      label: "Foreign Part 91",
      abbrev: "FrgnPrt91"
    },
    certificate_of_conformance: {
      label: "C of C Only",
      abbrev: "C of C"
    },
    foreign_operator: {
      label: "Foreign Operator",
      abbrev: "FrgnOp"
    },
    foreign_repair_station: {
      label: "Foreign Repair Station",
      abbrev: "Frgn145"
    },
    ntr: {
      label: "No Trace",
      abbrev: "NoTrace"
    },
    oem: {
      label: "OEM",
      abbrev: "OEM"
    },
    unknown: {
      label: "Unknown",
      abbrev: "UNK"
    }
  }
};

export const ATTACHMENT_TYPES = {
  tag_copies: {
    label: "Tag Copies"
  },
  traceability: {
    label: "Traceability"
  },
  photos: {
    label: "Photos"
  },
  customer_correspondence: {
    label: "Customer Correspondence"
  }
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/constants.js